var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewConsulting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.117,
    height: 19.117,
    viewBox: "0 0 19.117 19.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-timer",
    d: "M11.762,3V6.983a.8.8,0,1,0,1.593,0V4.753a7.909,7.909,0,1,1-8.762,7.805A7.908,7.908,0,0,1,6.462,7.44a.8.8,0,0,0-1.22-1.027A9.555,9.555,0,1,0,12.559,3ZM8.094,7.786a.36.36,0,0,0-.252.551c1.166,1.83,3.157,4.915,3.591,5.349a1.593,1.593,0,1,0,2.253-2.253C13.252,11,10.166,9.008,8.336,7.842A.351.351,0,0,0,8.094,7.786Z",
    transform: "translate(-3 -3)",
    fill: "#827565"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConsulting);
export default __webpack_public_path__ + "static/media/newConsulting.39093b3af63acd32c9f01789d1f68a4f.svg";
export { ForwardRef as ReactComponent };